<script>
import simplebar from "simplebar-vue";
import SideNav from "./side-nav-store";

export default {
  components: { simplebar, SideNav },
  props: {
    isCondensed: {
      type: Boolean,
      default: false
    },
    cart: {
      default: "",
    }
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60
      }
    };
  },

  methods: {}
};
</script>

<template>
  <div class="vertical-menu">
    <simplebar v-if="!isCondensed" :settings="settings" class="h-100">
      <SideNav :cart="cart" />
    </simplebar>

    <simplebar v-else class="h-100">
      <SideNav :cart="cart" />
    </simplebar>
  </div>
</template>

